import styled from "styled-components";
import { Typography } from "antd";

export const Container = styled.div`
  width: 100%;
  .progress_container {
    width: 100%;
    background-color: var(--velotax-ghost-white);
    height: 15px;
    position: relative;
    border-radius: 50px;
  }

  .loading_bar {
    height: 100%;
    background-color: var(--ant-primary-color);
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    display: flex; /* Para que os elementos dentro da barra de progresso se alinhem corretamente */
    align-items: center; /* Para centralizar verticalmente o texto */
    justify-content: center; /* Para alinhar o texto à esquerda dentro da barra de progresso */
    padding-left: 10px; /* Adicione o padding necessário para dar espaço ao texto na barra */
  }

  .progress_container_text_align_center {
    /* Estilos para o texto (se necessário) */
    font-size: 11px;
    font-weight: 700;
  }
  .recharts-responsive-container {
    height: auto !important;
    padding: 20px !important;
    margin: 10px 0 !important;

    @media only screen and (max-device-width: 812px) {
      padding: 0px !important;
      .recharts-wrapper {
        margin: 0px !important;
        padding: 0px !important;
      }
    }
  }
  .success {
    color: var(--ant-success-color);
  }
  .error {
    color: var(--ant-error-color);
  }
  .page-title {
    display: flex;
    align-items: baseline;
  }
  .hide-values-btn {
    width: 24px;
    margin-left: 12px;
    border-radius: 4px;
    display: inline-flex;
    height: 32px !important;
    background-color: transparent;
    svg {
      width: 20px;
      height: 20px;
      fill: var(--ant-primary-color) !important;
    }
  }

  .patrimonio {
    width: 100%;
    margin-top: -32px;
    margin-bottom: -32px;

    h1:not(.page-title) {
      padding-bottom: 70px;
      padding-left: 40px;
      font-size: 2.25rem;
      margin: 0 !important;
      color: var(--velotax-font-color-light);

      span {
        font-weight: 800;
      }

      :after {
        display: none;
      }
    }

    h2 {
      font-weight: 400;
      line-height: 1rem;
      padding-left: 40px;
      font-size: 0.875rem;
      margin: 0 !important;
      color: var(--velotax-font-color-light);
    }

    .lucro-prejuizo {
      padding: 16px 0 16px 16px;
      border-left: 2px solid #313131;

      .anticon.anticon-loading.anticon-spin {
        width: 14px;
        height: 14px;
        margin-left: 4px;
        svg {
          width: 14px;
          height: 14px;
        }
      }

      div.ant-typography {
        margin: 0.5rem 0;
        font-size: 0.875rem;
        span {
          font-weight: 600;
          white-space: nowrap;
        }
        & > span {
          display: block;
          &.error {
            margin: 0;
          }
        }
      }
    }
  }

  .list-empty {
    padding: 16px;
    margin-top: -16px;
    border-radius: 8px;
    color: var(--velotax-font-color);
    background-color: #e8e8e8;
  }

  .last-update {
    display: flex;
    margin-top: 32px;
    align-items: center;
    font-size: 0.75rem;
    line-height: 1.5rem;
    color: var(--ant-primary-color);
    .button-refresh-wallet {
      width: 20px;
      height: 20px;
      border: none;
      box-shadow: none;
      margin-right: 8px;
      background-color: var(--light-gray);
      color: var(--ant-primary-color) !important;
      svg {
        width: 10px !important;
        height: 10px !important;
        * {
          stroke: var(--ant-primary-color) !important;
        }
      }
    }
  }

  .messages {
    margin-top: 16px;
    font-weight: 400;
    padding-top: 16px;
    line-height: 1rem;
    font-size: 0.75rem;
    color: var(--velotax-font-color);
    border-top: 2px solid #313131;
    li {
      padding-left: 16px;
      margin-bottom: 6px;
      position: relative;
      .anticon-info-circle {
        left: 0;
        top: 1px;
        position: absolute;
        color: var(--velotax-font-color);
      }
    }
  }

  .select-container {
    top: 0;
    right: 0;
    width: 41.6666%; // 41.6666% para alinhar com o prejuizo (10/24 = 41.6666)
    position: absolute;
    .ant-select {
      min-width: 180px;
      height: 40px !important;
      .ant-select-selector {
        height: 40px !important;
      }
    }
  }
  .recharts-layer.recharts-pie-labels text {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  
  /* Remove bordas brancas do gráfico de pizza */
  .recharts-pie-sector {
    stroke: none !important;
  }
  
  .recharts-pie-sector path {
    stroke: none !important;
  }
  
    /* Remove bordas de todos os elementos do gráfico */
  .recharts-wrapper svg {

    stroke: none !important;
  }
  
  .recharts-pie {
    stroke: none !important;
  }
  
  /* Efeito 3D para o gráfico de pizza */
  .recharts-pie-sector {
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15)) !important;
    transition: all 0.3s ease !important;
  }
  
  .recharts-pie-sector:hover {
    filter: drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.25)) !important;
    transform: translateY(-2px) scale(1.02) !important;
  }
  
  /* Animação sutil de entrada */
  .recharts-pie-sector {
    animation: fadeInUp 0.6s ease-out;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Adiciona profundidade ao gráfico */
  .recharts-wrapper {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) !important;
    margin: 10px !important;
    padding: 10px !important;
  }
  
  /* Efeito de elevação para os setores */
  .recharts-pie-sector path {
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1)) !important;
  }
  
  /* Efeito de profundidade adicional */
  .recharts-pie-sector {
    position: relative;
  }
  
  .recharts-pie-sector::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%);
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
  }
  @media only screen and (min-device-width: 813px) {
    .velotax-content.largeChart {
      .recharts-responsive-container {
        margin: 0 auto 80px;
      }
    }
    .recharts-responsive-container {
      margin: 0 auto 48px;
      position: relative;
      .recharts-wrapper {
        width: 100% !important;
                 > .recharts-surface {
           margin-left: 0px !important;
         }
        .recharts-legend-wrapper {
          right: 0px !important;
          width: 41.6666% !important; // 41.6666% para alinhar com o prejuizo (10/24 = 41.6666)
          top: calc(48px + 20px) !important;
          .recharts-legend-item {
            margin: 4px 0;
            .recharts-surface {
              width: 16px;
              height: 16px;
              border-radius: 2px;
            }
            .recharts-legend-item-text {
              /* margin-left: 12px; */
              span {
                font-size: 14px;
                font-weight: 500;
                color: var(--velotax-font-color) !important;
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    .page-title {
      align-items: center;
      justify-content: space-between;
    }
    .patrimonio {
      margin-top: 0px;
      margin-bottom: -24px;

      h1:not(.page-title) {
        padding-bottom: 20px; 

      }

      h1,
      h2 {
        padding-left: 0 !important;
      }

      .lucro-prejuizo {
        padding: 4px 0 0;
        border: none;
        margin-top: -10px;
  


        .anticon.anticon-loading.anticon-spin {
          width: 10px;
          height: 10px;
          margin-left: 4px;
          svg {
            width: 10px;
            height: 10px;
          }
        }

        div.ant-typography {
          margin: 0.25rem 0;
          font-size: 0.75rem;
        }
      }
    }

    h1 {
      width: calc(100% - 48px);
      margin: 0 24px 1.5rem;
      padding: 24px 0 1rem;
    }

    .recharts-responsive-container {
      position: relative;
      margin: 32px auto;
      .select-container {
        top: -32px;
        width: 100%;
        .ant-select {
          min-width: 210px;
        }
      }
      .recharts-legend-wrapper {
        width: 98px !important;
        right: -24px !important;
        .recharts-legend-item {
          margin: 4px 0;
          align-items: start;
          display: flex !important;
          margin-right: 0 !important;
          .recharts-surface {
            border-radius: 2px;
            margin-top: 1px;
          }
          .recharts-legend-item-text {
            max-width: 80px;
            font-size: 13px;
            line-height: 14px;
            white-space: normal;
            display: inline-block;
            span {
              color: var(--velotax-font-color) !important;
            }
          }
        }
      }
    }
  }
`;

export const Content = styled.div`
  .ant-tooltip {
    z-index: 999;
    .ant-tooltip-inner {
      width: auto;
      white-space: nowrap;
    }
  }
  &.velotax-content {
    width: 100% !important;
    padding: 16px 0 27px !important;
    
    /* Estilos para os cards das corretoras */
    .corretoras-container {
      .corretoras-grid {
        @media (max-width: 768px) {
          flex-direction: column;
          
          .ant-col {
            margin-bottom: 12px;
          }
        }
        
        @media (max-width: 576px) {
          .ant-col {
            margin-bottom: 8px;
          }
        }
      }
      
      .corretora-card {
        transition: all 0.3s ease;
        
        @media (max-width: 768px) {
          padding: 8px;
          min-height: 80px;
        }
        
        @media (max-width: 576px) {
          padding: 6px;
          min-height: 70px;
        }
      }
    }
    
  }
  .container-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 32px;
  }
  .download-report-btn {
    padding: 5px;
    width: 24px;
    z-index: 1;
    font-size: 14px;
    border-radius: 4px;
    display: inline-flex;
    height: 32px !important;
    background-color: var(--white);
    color: var(--velotax-font-color-dark);
    width: 32px;
    border: 1px solid var(--light-gray);
    border-radius: 60px;
    svg {
      width: 16px;
      height: 16px;
      fill: var(--ant-primary-color) !important;
    }
    &.filter-btn {
      width: auto;
      margin-right: 8px;
      padding: 5px 12px;
      svg {
        stroke: var(--ant-primary-color) !important;
        fill: none !important;
      }
    }
  }
  .range {
    display: flex;
    justify-content: space-between;

    div.ant-typography {
      font-size: 13px;
    }
  }
  .ant-tabs-tabpane {
    min-height: 547px;
  }
  .isentometro {
    margin-bottom: 5px;
    font-size: 14px;
  }
  .box {
    margin: 50px 0px;
  }
  .overview {
    color: var(--ant-primary-color);
    font-size: 18px;
    font-weight: bold;
  }
  .ant-progress-success-bg {
    background-color: var(--ant-primary-color);
    height: 13px !important;
  }
  .ant-progress-inner {
    height: 13px !important;
  }
  .ant-progress-bg {
    height: 13px !important;
  }
  & > .ant-collapse {
    border: none;
    & > .ant-collapse-item.ativos-categoria {
      margin-bottom: 48px;
      &:last-of-type {
        margin-bottom: 0;
      }
      & > .ant-collapse-header {
        padding: 0;
        align-items: center;
        .ant-collapse-arrow {
          right: 0;
        }
        h2 {
          margin: 0;
          font-weight: 700;
          font-size: 1.125rem;
          line-height: 1.5rem;
          color: var(--ant-primary-color);
        }
        .collapse-title-divider {
          flex-grow: 1;
          display: block;
          margin: 0 16px;
          border-bottom: 2px solid #313131;
        }
        .collapse-title-hidden {
          width: 24px;
          height: 24px;
          display: block;
          visibility: hidden;
        }
      }
      & > .ant-collapse-content {
        border: none;
        background-color: transparent;
        & > .ant-collapse-content-box {
          padding: 24px 0 0;
          & > .ant-collapse {
            border: none;
          }
          & > div {
            font-size: 13px;
          }
        }
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    width: 100%;
    margin-bottom: 0;
    border-radius: 0;
    padding: 32px 24px;

    h1,
    h2 {
      padding: 0;
    }
  }
`;

export const BlurContent: any = styled.div`
  margin-top: 8px;
  position: relative;
  user-select: none;
  border-radius: 4px;
  border: 2px solid #313131;
  .blur-content {
    opacity: 0.5;
    filter: blur(4px);
  }
  .blur-content-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 100px;
    font-weight: 500;
    font-size: 1.25rem;
    text-align: center;
    row-gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: var(--velotax-font-color-light);
  }

  @media only screen and (max-device-width: 812px) {
    .blur-content-title {
      padding: 0 16px;
      font-size: 1rem;
    }
  }
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  margin: 0 auto 1.5rem;
  justify-content: space-between;

  @media only screen and (max-device-width: 812px) {
    width: 100%;
  }
`;

export const IsentCardStyled = styled.div`
  margin-bottom: 4px;
  height: 110px;
  padding: 23px;
  border: none !important;
  border-radius: 4px !important;
  background-color: var(--velotax-background-color-ghost);
  text-align: center;
  gap: 12px;
  flex-direction: column;
  display: flex;

  .overviewTitleIsent {
    color: var(--ant-primary-color);
    font-size: 13px;
  }

  .ant-tooltip-inner {
    display: flex;
    justify-content: center;
    width: 315px;
    padding: 5px;
  }
`;

export const ResponsiveCard = styled.div`
  width: 100%;
  min-height: 120px;
  padding: 16px 12px;
  border: 1px solid #B8860B;
  border-radius: 12px;
  background-color: #fafafa;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  }

  @media (max-width: 768px) {
    min-height: 100px;
    padding: 12px 8px;
  }

  @media (max-width: 480px) {
    min-height: 90px;
    padding: 10px 6px;
  }
`;

export const CorretoraName = styled(Typography.Text)`
  display: block;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.2;
  word-break: break-word;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 6px;
  }
`;

export const CorretoraValue = styled(Typography.Text)`
  display: block;
  color: black;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.1;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const CorretoraPercentage = styled(Typography.Text)`
  display: block;
  color: #666;
  font-size: 13px;
  font-weight: 600;
  background-color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #ddd;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 3px 6px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
    padding: 2px 4px;
  }
`;

export const ResponsiveTitle = styled(Typography.Title)`
  font-size: ${props => props.level === 1 ? '32px' : '24px'};
  line-height: 1.2;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: ${props => props.level === 1 ? '24px' : '20px'};
  }

  @media (max-width: 480px) {
    font-size: ${props => props.level === 1 ? '20px' : '18px'};
  }
`;
